w = $(this).width();

// タブ切り替え
  var tab = $('[role="tab"]'),
    tabpanel = $('[role="tabpanel"]');

  function tabChange(o) {
    var _self = $(o),
      select = _self.attr('aria-selected'),
      id = _self.attr('aria-controls'),
      id_body = $('#' + id);

    // 初期化
    $('.nav-link').removeClass("active");
    tabpanel.attr('aria-hidden', true);
    tab.attr('aria-selected', false);


    _self.parent().addClass("active");

    id_body.attr('aria-hidden', false);

    _self.attr('aria-selected', true);
  }

  tab.stop().on('click', function () {
    tabChange(this);
  });
  $('a[href^="#"]').click(function(){
    var speed = 1500;
    var href= $(this).attr("href");
    if($.inArray(href, ["#recover","#login"]) === -1){
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 63;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
    }
  });

  $('input[name="id"]').on('change', function () {
    setTimeout(function(){
      var changePrice = $('.price__sale .price-item__num').text();
      var removed = changePrice.replace(/,/g, '');
      var changeNum = parseInt(removed, 10);
      $('.tax_excluded .price-item__num').text( (changeNum / 1.1).toLocaleString());
      $('span[data-loyal-target="point-value-location"]').text( String(Math.ceil(changeNum / 110 * 2)) );
    }, 500);
  });

function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(window).on('load', function(){
  var introductionID = getParam('i_id');
  if (introductionID && navigator.cookieEnabled)  //cookieが使えるか確認
  {
    document.cookie = "introductionID=" + introductionID;
  }  
});

// モーダルウィンドウ
$('.modal_btn').each(function () {
  $(this).on('click', function () {
    var target = $(this).data('target');
    var modal = document.getElementById(target);
    
    $(modal).fadeIn(300).addClass("active");

    return false;
  });
});

// ウィンドウを閉じる
$('.js-modal-close, .crossーclose').on('click', function () {
  $('.js-modal').fadeOut(300).removeClass("active");

  return false;
});

// top-kv
// var mySwiper = new Swiper ('.kv-slide', {
//   // Optional parameters
//   direction: 'horizontal',
//   loop: true,
//   // ページネーション
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   on: {
//     transitionStart: function(){
//       var videos = document.querySelectorAll('video');
//       Array.prototype.forEach.call(videos, function(video){
//         video.pause();
//       });
//     },
//     transitionEnd: function(){
//       var activeIndex = this.activeIndex;
//       var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
//       var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
//       activeSlideVideo.play();
//     },
//   }
// });
var kvSlide = new Swiper ('.kv-slide', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});

// 商品のスライダー
( w < 768) ? slidesView = 2 : slidesView = 4;

const slideLength = document.querySelectorAll('.related-slide-list .swiper-slide').length;
if (slideLength > slidesView) {
var relatedList = new Swiper ('.related-slide-list', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: slidesView,
   spaceBetween: 20,
  // ページネーション
  pagination: {
    el: ".related-slide-list .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    769: {
      spaceBetween: 40,
      navigation: {
        nextEl: ".related-slide-button-next",
        prevEl: ".related-slide-button-prev",
      }
    }
  }
});
}else{
  $('.related-slide-list .swiper-button-prev, .related-slide-list .swiper-button-next').remove();
}

// おすすめアイテム
const recommendedSlideLength = document.querySelectorAll('.recommended-slide-list .swiper-slide').length;
if (recommendedSlideLength > slidesView) {
var recommendedList = new Swiper ('.recommended-slide-list', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: slidesView,
   spaceBetween: 20,
  // ページネーション
  pagination: {
    el: ".recommended-slide-list .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    769: {
      spaceBetween: 40,
      navigation: {
        nextEl: ".recommended-slide-button-next",
        prevEl: ".recommended-slide-button-prev",
      }
    }
  }
});
}

// ベストセラー
const bestsellerSlideLength = document.querySelectorAll('.bestseller-slide-list .swiper-slide').length;
if (bestsellerSlideLength > slidesView) {
var bestSellerList = new Swiper ('.bestseller-slide-list', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: slidesView,
  spaceBetween: 20,
  // ページネーション
  pagination: {
    el: ".bestseller-slide-list .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    769: {
      spaceBetween: 40,
      navigation: {
        nextEl: ".bestseller-slide-button-next",
        prevEl: ".bestseller-slide-button-prev",
      }
    }
  }
});
}

// 成分一覧のフィルター
$(function(){
   var $btn = $('.filter-btn [data-filter]'),
       $list = $('.ingredient__list [data-initial]');
 
   $btn.on('click', function(e) {
     e.preventDefault();
     
     var $btnCat = $(this).attr('data-filter');
     $btn.removeClass('selected');
	 $list.removeClass('is-animate');
     $(this).addClass('selected');
     
     if ($btnCat == 'all') {
       
       $list.fadeOut().promise().done(function() {
         $list.addClass('is-animate').fadeIn();
       });
     
     } else {
	 
       $list.fadeOut().promise().done(function() {
         $list.filter('[data-initial = "' + $btnCat + '"]').addClass('is-animate').fadeIn();
       });
	   
     }
   });
 });
